/**
 * CarrierTile — the Versicherer initials tile (design.md §4: 8px-radius icon
 * tile). Ported from the reference prototype's company-logo.tsx, but INITIALS
 * ONLY: no external favicon/logo fetch — the artifact CSP + zero-network tests
 * forbid third-party logo services, and the design keeps carrier chrome neutral.
 *
 * [Source: brokly-design-reference/components/brokly/company-logo.tsx]
 * [Source: docs/design/2026-07-10_sebastian-package/design.md §4]
 */
import { cn } from '../../../lib/cn';

/** Up to two initials from a company name (single word → first two letters). */
export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '-';
  if (words.length === 1) return words[0]!.slice(0, 2).toUpperCase();
  return (words[0]![0]! + words[1]![0]!).toUpperCase();
}

export function CarrierTile({ name, className }: { name: string; className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex size-8 shrink-0 items-center justify-center rounded-lg bg-secondary text-xs font-medium text-muted-foreground',
        className,
      )}
    >
      {initialsOf(name)}
    </span>
  );
}
